export class WindowUtil
{
    public static getWindow():Window
    {
        return window;
    }

    public static addFullScreenChangeListener(listener:Function):void
    {
        window.addEventListener(`webkitfullscreenchange`, (e)=>(listener(e)));
        window.addEventListener(`mozfullscreenchange`, (e)=>(listener(e)));
        window.addEventListener(`fullscreenchange`, (e)=>(listener(e)));
    }

    public static isFullScreen():boolean
    {
        var d:any = document;
        return d.fullscreen || d.mozFullScreen || d.webkitIsFullScreen || d.msFullscreenElement;
    }
}